/** Client-only logo blob from onboarding (avoid huge base64 in DB). */
export function odcLogoStorageKey(businessId: string): string {
  return `odc_logo_${businessId}`;
}

export function readOdcLogo(businessId: string): string | null {
  try {
    return localStorage.getItem(odcLogoStorageKey(businessId));
  } catch {
    return null;
  }
}

export function writeOdcLogo(businessId: string, dataUrl: string): void {
  try {
    localStorage.setItem(odcLogoStorageKey(businessId), dataUrl);
  } catch {
    /* quota / private mode */
  }
}

export function clearOdcLogo(businessId: string): void {
  try {
    localStorage.removeItem(odcLogoStorageKey(businessId));
  } catch {
    /* ignore */
  }
}
